var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCommunity(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 802.704,
    height: 751.589,
    viewBox: "0 0 802.704 751.589",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    role: "img",
    artist: "Katerina Limpitsouni",
    source: "https://undraw.co/",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_188",
    "data-name": "Group 188",
    transform: "translate(-591 -185.668)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3038-3412",
    "data-name": "Path 3038",
    d: "M1025.138,691.957H224.566c-.589,0-1.066-.779-1.066-1.741s.477-1.741,1.066-1.741h800.572c.589,0,1.066.779,1.066,1.741S1025.726,691.957,1025.138,691.957Z",
    transform: "translate(367.5 226.498)",
    fill: "#cacaca"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_493",
    "data-name": "Ellipse 493",
    cx: 11.689,
    cy: 11.689,
    rx: 11.689,
    ry: 11.689,
    transform: "translate(687.22 666.759)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_494",
    "data-name": "Ellipse 494",
    cx: 11.689,
    cy: 11.689,
    rx: 11.689,
    ry: 11.689,
    transform: "translate(738.472 750.083)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_495",
    "data-name": "Ellipse 495",
    cx: 11.689,
    cy: 11.689,
    rx: 11.689,
    ry: 11.689,
    transform: "translate(698.909 738.689)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3079-3413",
    "data-name": "Path 3079",
    d: "M351.649,672.223c-.206-.337-5.072-8.461-6.758-25.33-1.547-15.477-.552-41.563,12.977-77.952,25.63-68.936-5.907-124.558-6.229-125.112l1.556-.9c.082.14,8.219,14.322,13.027,36.9a161,161,0,0,1-6.668,89.738c-25.586,68.819-6.564,101.4-6.369,101.718Z",
    transform: "translate(362.676 244.062)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3080-3414",
    "data-name": "Path 3080",
    d: "M336.4,431.319a12.588,12.588,0,1,1,12.588-12.588A12.588,12.588,0,0,1,336.4,431.319Zm0-23.377a10.789,10.789,0,1,0,10.789,10.789A10.789,10.789,0,0,0,336.4,407.942Z",
    transform: "translate(367.902 253.423)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_496",
    "data-name": "Ellipse 496",
    cx: 11.689,
    cy: 11.689,
    rx: 11.689,
    ry: 11.689,
    transform: "translate(729.481 703.624)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3081-3415",
    "data-name": "Path 3081",
    d: "M352.081,527.8a12.588,12.588,0,1,1,12.588-12.588A12.588,12.588,0,0,1,352.081,527.8Zm0-23.377a10.789,10.789,0,1,0,10.79,10.789,10.789,10.789,0,0,0-10.79-10.789Z",
    transform: "translate(363.911 228.869)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3082-3416",
    "data-name": "Path 3082",
    d: "M393.087,560.367a12.588,12.588,0,1,1,12.588-12.588,12.588,12.588,0,0,1-12.588,12.588Zm0-23.377a10.789,10.789,0,1,0,10.789,10.789A10.79,10.79,0,0,0,393.087,536.989Z",
    transform: "translate(353.474 207.698)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Ellipse_497",
    "data-name": "Ellipse 497",
    cx: 11.689,
    cy: 11.689,
    rx: 11.689,
    ry: 11.689,
    transform: "translate(695.314 794.434)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3083-3417",
    "data-name": "Path 3083",
    d: "M362.976,733.886s-11.689-28.772,23.377-50.351Z",
    transform: "translate(358.41 182.829)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3084-3418",
    "data-name": "Path 3084",
    d: "M328.462,740.018s-5.32-30.6-46.492-30.334Z",
    transform: "translate(378.55 176.175)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3085-3419",
    "data-name": "Path 3085",
    d: "M781.489,701.255H643.328s-2.8-41.075,13.769-41.541,14.7,18.2,35.474-7.468,45.976-24.271,49.243-9.1-6.3,27.305,11.2,23.571S795.725,672.783,781.489,701.255Z",
    transform: "translate(536.137 213.093)",
    fill: "#d6d6e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3086-3420",
    "data-name": "Path 3086",
    d: "M771.989,701.04l-.466-.019c1.088-27.043,6.751-44.419,11.311-54.233,4.951-10.656,9.722-14.97,9.769-15.013l.31.349c-.047.042-4.762,4.313-9.673,14.9C778.705,656.794,773.072,674.1,771.989,701.04Z",
    transform: "translate(474.224 213.318)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3087-3421",
    "data-name": "Path 3087",
    d: "M868.592,737.3l-.448-.13a72.406,72.406,0,0,1,18.229-30.328l.314.345A71.914,71.914,0,0,0,868.592,737.3Z",
    transform: "translate(427.626 177.116)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3088-3422",
    "data-name": "Path 3088",
    d: "M687.58,772.42l-.971-.135c3.843-27.714-3.1-49.216-9.6-62.373-7.038-14.246-15.068-22.027-15.148-22.1l.678-.707c.082.078,8.236,7.979,15.349,22.377C684.45,722.759,691.457,744.459,687.58,772.42Z",
    transform: "translate(397.38 141.311)",
    fill: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3089-3423",
    "data-name": "Path 3089",
    d: "M786.263,686.114H614.45l-.04-.582c-.1-1.448-2.29-35.6,8.775-47.785a12.12,12.12,0,0,1,8.857-4.25c7.213-.205,11.746,2.5,15.4,4.665,6.891,4.088,11.444,6.789,28-13.669,17.931-22.162,37.278-26.93,48.4-24.279,7.186,1.713,12.139,6.556,13.588,13.286,1.373,6.372.935,12.36.584,17.171-.376,5.148-.673,9.214,1.441,11.057,1.765,1.538,5.288,1.677,11.086.44,11.794-2.516,28.249-.363,36.509,10.309,4.444,5.741,7.945,16.178-.612,33.292Zm-170.641-1.249H785.49c6.376-12.937,6.576-23.866.571-31.624-7.577-9.79-23.474-12.367-35.261-9.852-6.3,1.344-10.053,1.122-12.167-.72-2.585-2.252-2.268-6.593-1.867-12.089.346-4.732.776-10.62-.559-16.818-1.344-6.241-5.958-10.736-12.657-12.333-10.767-2.569-29.573,2.139-47.139,23.849-17.23,21.3-22.421,18.218-29.6,13.958-3.7-2.2-7.9-4.685-14.73-4.491a10.916,10.916,0,0,0-7.968,3.841C614.165,649.537,615.379,680.248,615.623,684.865Z",
    transform: "translate(550.113 228.86)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3090-3424",
    "data-name": "Path 3090",
    d: "M613.505,191.765s-20.247-7.231-33.263,21.694S546.979,274.2,546.979,274.2l11.57,2.892s2.892-20.247,10.124-23.14l-2.892,26.032s74.41,30.371,113.458-2.892l4.339-10.362v10.362l10.124-4.577s-4.339-8.677-17.355-20.247a40.264,40.264,0,0,1-13.217-26.229,37.6,37.6,0,0,0-8.657-20.478C645.822,195.537,637.368,180.276,613.505,191.765Z",
    transform: "translate(387.413 97.981)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3091-3425",
    "data-name": "Path 3091",
    d: "M593.774,311.075,572.8,284.861l-15.728-53.738L617.366,166.9s13.107-49.806,1.311-47.184-14.417,39.32-14.417,39.32l-76.02,58.981s7.864,82.573,30.146,111.408l17.039,53.738Z",
    transform: "translate(385.788 92.078)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3092-3426",
    "data-name": "Path 3092",
    d: "M643.99,311.075l20.971-26.214,15.728-53.738L620.4,166.9s-13.107-49.806-1.311-47.184,14.417,39.32,14.417,39.32l76.02,58.981s-7.864,82.573-30.146,111.408l-17.039,53.738Z",
    transform: "translate(393.242 92.078)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_499",
    "data-name": "Ellipse 499",
    cx: 31.436,
    cy: 31.436,
    r: 31.436,
    transform: "translate(977.951 314.889)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3093-3427",
    "data-name": "Path 3093",
    d: "M601.646,260.815s1.311,27.524-6.553,36.7-15.728,56.359,22.282,57.67,34.078-39.32,34.078-39.32l-7.864-22.282s-11.8-17.039-7.864-32.767Z",
    transform: "translate(391.023 104.328)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3094-3428",
    "data-name": "Path 3094",
    d: "M568.354,541.824l28.18,8.519s22.937-13.762,22.937-.655-7.864,30.146-5.243,41.942,7.864,40.631,0,40.631-23.592-51.117-23.592-51.117l-26.214-14.417Z",
    transform: "translate(388.927 128.707)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3095-3429",
    "data-name": "Path 3095",
    d: "M601.766,710.671,591.28,751.3s-9.175,11.8,0,17.039c4.305,2.46,7.456,7.518,9.588,12.193a22.417,22.417,0,0,0,22.012,13.317c4.474-.371,8.242-2.14,9.159-6.736a10.547,10.547,0,0,0-2.03-8.26c-9.668-13.065-11.86-21.655-11.86-21.655l3.932-45.874Z",
    transform: "translate(390.903 143.356)",
    fill: "#ffb9b9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3096-3430",
    "data-name": "Path 3096",
    d: "M577.365,253.31s13.026-25.689,23.149-28.582,13.628,0,13.628,0,22.518,11.57,38.427,13.016,1.446-24.929,1.446-24.929l-28.925-7.231-27.478,2.892-21.694,14.462Z",
    transform: "translate(389.924 99.536)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3097-3431",
    "data-name": "Path 3097",
    d: "M566.965,451.278l-5.243,10.485S434.586,502.395,445.072,540.4s69.466,27.524,69.466,27.524l65.534,11.8,6.553-28.835-45.874-11.8,78.641-28.835,2.621,133.689-10.485,95.68,26.214,2.621s28.835-87.816,24.9-124.515c0,0,48.5-149.418,20.971-171.7S566.965,451.278,566.965,451.278Z",
    transform: "translate(378.519 119.641)",
    fill: "#090814"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3098-3432",
    "data-name": "Path 3098",
    d: "M622.053,313.59,601.6,288.874l-13.852,6.349L573.332,341.1s-11.8,22.282,2.621,45.874c0,0,2.621,15.728-1.311,19.66s-5.243,28.835-5.243,28.835l-17.039,32.767s96.99,17.039,125.825-6.553c0,0-15.131-55.784-5.956-72.823s10.485-43.16,0-54.956-21.568-42.609-21.568-42.609l-6.347-4.06Z",
    transform: "translate(387.88 106.619)",
    fill: "#6c63ff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3099-3433",
    "data-name": "Path 3099",
    d: "M461.613,88.424H449.043V75.853H447.9V88.424H435.33v1.142H447.9v12.571h1.142V89.566h12.571Z",
    transform: "translate(624.782 136.098)",
    fill: "#cfcce0"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3100-3434",
    "data-name": "Path 3100",
    d: "M351.681,64.239H339.111V51.668h-1.142V64.239H325.4v1.142h12.57V77.951h1.142V65.381h12.571Z",
    transform: "translate(615.244 134)",
    fill: "#cfcce0"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCommunity);
export default __webpack_public_path__ + "static/media/community.9e9ccc11e697e020129a646eefedf76a.svg";
export { ForwardRef as ReactComponent };